import { ContactElement } from '@swagger-api/apidom-ns-openapi-3-0';

/**
 * @public
 */
class Contact extends ContactElement {}
export default Contact;